import { isNil, omitBy } from 'lodash';
import { Union } from 'ts-toolbelt';

import { InitialValues, ValidationErrors } from 'forms/types';
import { composeValidators, isDateInPast, isDateOnOrAfterDOB, isPresent } from 'forms/validators';

import { BloodPressureFormValues } from '../form/types';

export const getValidator = ({ dateOfBirth }: { dateOfBirth: Union.Nullable<string> }) => {
  const dobValidator = composeValidators(isPresent, isDateInPast, isDateOnOrAfterDOB(dateOfBirth));

  return ({
    systolicPressure,
    diastolicPressure,
    lastTreatedAt,
    controlledWithMedicationSince,
    controlledWithMedication,
  }: InitialValues<BloodPressureFormValues>): ValidationErrors<BloodPressureFormValues> => {
    const errors: ValidationErrors<BloodPressureFormValues> = {
      systolicPressure: isPresent(systolicPressure),
      diastolicPressure: isPresent(diastolicPressure),
      lastTreatedAt: dobValidator(lastTreatedAt),
      controlledWithMedication: isPresent(controlledWithMedication),
    };

    if (controlledWithMedication) {
      errors.controlledWithMedicationSince = dobValidator(controlledWithMedicationSince);
    }

    return omitBy(errors, isNil);
  };
};
